<template>
    <a-spin :spinning="confirmLoading">
      <a-tabs defaultActiveKey="1" type="card" @tabClick="onTabClick">
        <a-tab-pane tab="当前版本" key="1">
          <j-form-container :disabled="formDisabled">
        <a-form :form="form" slot="detail">
          <a-row>
            <a-col :span="24" v-if="isEdit">
              <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-search-select-tag type="list" v-decorator="['projId', validatorRules.name]" :trigger-change="true"
                                     dict="proj_project,name,id" :async="true" placeholder="请选择项目" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-else> <!--新增情况,过滤掉已经提交的-->
              <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-search-select-tag type="list" v-decorator="['projId', validatorRules.name]" :trigger-change="true"
                                     :dictOptions="projectOptions" placeholder="请选择项目"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="采购形式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag v-decorator="['bidForm', validatorRules.bidForm]" :trigger-change="true"
                                   placeholder="请选择采购形式" dictCode="bms_project_bid_form"></j-dict-select-tag>
                </a-form-item>
            </a-col>
            <a-col :span="24">
                <a-form-item label="采购编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['purchaseCode', validatorRules.purchaseCode]" placeholder="请输入采购编号" ></a-input>
                </a-form-item>
            </a-col>    

            <a-col :span="24">
                <a-form-item label="中标人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['bidWinner', validatorRules.bidWinner]" placeholder="请输入中标人" ></a-input>
                </a-form-item>
            </a-col> 
            <a-col :span="24">
                <a-form-item label="费率(‰)" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number :max="100" v-decorator="['offerRate', validatorRules.offerRate]" placeholder="请输入中标人费率" style="width: 100%;"></a-input-number>
                </a-form-item>
            </a-col> 
            <a-col :span="24">
                <a-form-item label="报价(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number :max="9999999999.00" v-decorator="['offerPrice', validatorRules.offerPrice]" placeholder="请输入中标人报价" style="width: 100%;"></a-input-number>
                </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="附件用印方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag v-decorator="['seal', validatorRules.seal]" :trigger-change="true" placeholder="请选择用印种类" dictCode="bms_seal_type"></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="报价汇总表附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-upload v-decorator="['file']" :trigger-change="true" :disabled="disabled" bizPath="project-purchase" @change="handleFileChange"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="审批备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea rows="3" v-decorator="['sealRemark', {}]" placeholder="审批任务中的文件说明"></a-textarea>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="isAuditReturn">
                <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea rows="3" v-decorator="['auditRemark', {}]" placeholder="审批意见" disabled></a-textarea>
                </a-form-item>
            </a-col>  

            <a-col :span="24" v-if="!formDisabled"> 
              <a-form-item label="模板下载" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a style="margin-right:30px;" :href="`${path}报价汇总表模板.xls`" download="报价汇总表模板.xls">报价汇总表模板</a>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </j-form-container>
        </a-tab-pane>
        <a-tab-pane v-for="version in tabs" :tab="version" :key="version">
          <j-form-container :disabled="formDisabled">
            <a-form slot="detail">
              <a-row>
                <a-col :span="24">
                  <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!-- 历史版本 tab 为只读回显，tabModel.name 存的是项目名称文本(非 id)，
                       用 proj_project,name,id 字典匹配不上(该字典 value 是 id)，原先靠 a-select
                       找不到 option 时回退显示原值才正常，代价是每次都全量拉 1469 条项目。
                       直接用只读输入框显示该文本，效果一致且不再请求字典。 -->
                    <a-input v-model="tabModel.name" disabled/>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="采购形式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-dict-select-tag v-model="tabModel.bidForm"  dictCode="bms_project_bid_form" disabled></j-dict-select-tag>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="采购编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="tabModel.purchaseCode"   disabled></a-input>
                  </a-form-item>
                </a-col>

                <a-col :span="24">
                  <a-form-item label="中标人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="tabModel.bidWinner"   disabled></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="费率(‰)" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input-number :max="100" v-model="tabModel.offerRate"  style="width: 100%;" disabled></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="报价(元)" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input-number :max="9999999999.00" v-model="tabModel.offerPrice" style="width: 100%;" disabled></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="附件用印方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-dict-select-tag v-model="tabModel.seal" dictCode="bms_seal_type" disabled></j-dict-select-tag>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="报价汇总表附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-upload v-model="tabModel.file" :disabled="disabled" bizPath="project-purchase" disabled/>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="审批备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-textarea rows="3" v-model="tabModel.sealRemark"  disabled></a-textarea>
                  </a-form-item>
                </a-col>
                <a-col :span="24" v-if="isAuditReturn">
                  <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-textarea rows="3" v-model="tabModel.auditRemark"  disabled></a-textarea>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </j-form-container>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </template>
  
  <script>
  
    import { httpAction, postAction, getAction } from '@/api/manage'
    import pick from 'lodash.pick'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import JDate from '@/components/jeecg/JDate'
    import JDictSelectTag from "@/components/dict/JDictSelectTag"
    import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
    import JEditor from '@/components/jeecg/JEditor'
    import JUpload from '../../../../components/jeecg/JUpload'
    import ProjectStatus from '../../ProjectStatus'
    import ProjectConst from '@views/project/ProjectConst'

    export default {
      name: 'ProjectPlanApplyForm',
      components: {
        JUpload,
        JFormContainer,
        JDate,
        JSearchSelectTag,
        JDictSelectTag,
        JEditor,
      },
      props: {
        //表单data
        formData: {
          type: Object,
          default: ()=>{},
          required: false
        },
        //表单禁用
        disabled: {
          type: Boolean,
          default: false,
          required: false
        }
      },
      data () {
        return {
          projectOptions: [],
          tabs: [],
          tabModel: {},
          description: '保险采购结果页面',
          form: this.$form.createForm(this),
          path: ProjectConst.OSS_ADR_TEMPLATE,
          isEdit: false,
          projectStatus:{},
          model: {
          },
          labelCol: {
            xs: { span: 24 },
            sm: { span: 5 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
          },
          confirmLoading: false,
          validatorRules: {
            name: {
              rules: [
                { required: true, message: '请选择项目!'},
              ]
            },     
            purchaseCode: {
              rules: [
                /*{ required: true, message: '请输入采购编号!'},*/
                { max: 50, message: '项目简称长度不能超过50个字符!'},
                { whitespace: true, message:'不能为空格'}
              ]
            }, 
            bidForm: {
              rules: [
                { required: true, message: '请选择采购形式!'},
              ]
            },
            seal: {
              rules: [
                { required: true, message: '请选择用印方式!'},
              ]
            },
            bidWinner:{
                rules: [
                //{ required: true, message: '请输入中标人!'},
                { max: 255, message: '项目简称长度不能超过255个字符!'},
                { whitespace: true, message:'不能为空格'}
              ]  
            },
            offerPrice:{
                rules: [
                //{ required: true, message: '请输入报价!'},
                //{ max: 999999999, message: '项目报价最大值不能超过999999999.00!'},
              ]  
            },
            offerRate:{
                rules: [
                //{ required: true, message: '请输入费率!'},
              ]  
            },            
          },
          url: {
            add: "/project/purchase/add",
            edit: "/project/purchase/edit",
            queryById: "/project/purchase/queryById",
            updateFilePath:"/project/purchase/updateFilePathImmediate",
            hisData:"/project/purchase/hisData",
          }
        }
      },
      computed: {
        formDisabled(){
          return this.disabled
        },

        isAuditReturn(){
          return (this.model.status === this.projectStatus.PURCHASE_WAIT && this.model.auditRemark != undefined)
        },
      },
      created () {
        this.projectStatus = ProjectStatus
        this.loadProjectOptions()
      },
      methods: {
        loadProjectOptions() {
          getAction("/project/baseInfo/optionList", {status: this.projectStatus.PURCHASE_WAIT}).then(res => {
            if (res.success) {
              this.projectOptions = res.result || []
            } else {
              this.$message.warning(res.message)
            }
          })
        },
        onTabClick(key) {
          if(key == 1) {return;}
          let url = this.url.hisData;
          let tempModel = this.tabModel;
          let param = {version: key,projId: this.tabModel.projId};
          postAction(url,param).then((res)=>{
            if(res.success){
              if(res.result){
                Object.keys(res.result).forEach(key => {
                  tempModel[key] = res.result[key]
                })
              } else {
                callback('未找到该项目');
              }
            }else{
              callback(res.message);
            }
          })
        },
        add () {
          this.edit({});
        },
        edit (record) {
          this.form.resetFields();
          this.model = Object.assign({}, record);
          //编辑、详情禁止修改
          if(this.model.id){
            this.isEdit = true;
          }else{ // 新增可以修改
            this.isEdit = false;
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'projId','purchaseCode', 'bidForm', 'bidWinner',
              'offerRate', 'offerPrice', 'status', 'file','auditRemark','seal','sealRemark'))
          })
          let vs = this.model.versions
          debugger;
          if(vs) {
            this.tabModel = Object.assign({}, record);
            this.tabs = vs.split(',');
          } else {
            this.tabs = []
          }
        },

        // 文件变化
        handleFileChange(filePath){
          // if(true)return;
          // // 编辑状态下变化，存在单据id
          // let id = this.model.id
          // if(id){
          //   postAction(this.url.updateFilePath, {id: id, filePath: this.filterFilePath(filePath)}).then(res =>{
          //     if(res.success){
          //     } else {
          //       this.$message.warn("附件更新时出现错误:" + res.message)
          //     }
          //   })
          // }
        },

        // filterFilePath(filePath) {
        //   const prefix = "https://ja-001.oss-cn-qingdao.aliyuncs.com/project/bms/";
        //   return filePath.split(",").map(file => file.replace(prefix, "")).join(",");
        // },
  
        submitForm(){
          const that = this;
          this.form.validateFields((err, values) => {
            if (!err) {
              that.confirmLoading = true;
              let httpurl = '';
              let method = '';
              if(!this.model.id){
                httpurl+=this.url.add;
                method = 'post';
              }else{
                httpurl+=this.url.edit;
                method = 'put';
              }
              let formData = Object.assign(this.model, values);
  
              this.trimFormData(formData);
  
              httpAction(httpurl,formData,method).then((res)=>{
                if(res.success){
                  that.$message.success(res.message);
                  that.$emit('ok');
                }else{
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
              })
            }
  
          })
        },
  
        trimFormData(formData){
          formData.purchaseCode = formData.purchaseCode ? formData.purchaseCode.trim() : '';
          formData.bidWinner = formData.bidWinner ? formData.bidWinner.trim() : '';
        },
  
        popupCallback(row){
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'projId','purchaseCode', 'bidForm', 'bidWinner',
              'offerRate', 'offerPrice', 'status', 'file','auditRemark','seal','sealRemark'))
          })
        },
      }
    }
  </script>
  
  <style>
  
  </style>